import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  useEffect(() => {
    const menuBtn = document.querySelector("div.menuBtn");
    const closeBtn = document.querySelector("button.close");
    const menu = document.querySelector("div.menu");
    const menuLinks = document.querySelectorAll("div.menu ul li");

    function openMenu() {
      menuBtn.classList.add("hidden");
      menu.classList.add("shown");
    }

    function closeMenu() {
      menuBtn.classList.remove("hidden");
      menu.classList.remove("shown");
    }

    menuBtn.addEventListener("click", () => openMenu());
    closeBtn.addEventListener("click", () => closeMenu());

    menuLinks.forEach((link) => {
      link.addEventListener("click", () => closeMenu());
    });
  });

  return (
    <>
      <div id="navbar">
        <div id="logo">
          <Link to="/">
            <h2>Tropical Roleplay</h2>
          </Link>
        </div>
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/faq">FAQ</Link>
          </li>
          <li>
            <Link to="/applications">Applications</Link>
          </li>
          <li>
            <Link to="/staff">Staff</Link>
          </li>
          <li>
            <Link
              to="https://www.youtube.com/@TropicalRoleplayOfficial_"
              rel="noopener"
              target="_blank"
            >
              <button className="yt">
                <i className="fa-brands fa-youtube"></i>YouTube
              </button>
            </Link>
          </li>
          <li>
            <Link
              to="https://dsc.gg/tropicalroleplay"
              rel="noopener"
              target="_blank"
            >
              <button className="discord">
                <i className="fa-brands fa-discord"></i>Discord
              </button>
            </Link>
          </li>
          <li>
            <Link
              to="https://cfx.re/join/og6jk7"
              rel="noopener"
              target="_blank"
            >
              <button className="connect">
                <i class="fa-solid fa-rocket"></i>Connect
              </button>
            </Link>
          </li>
        </ul>
      </div>
      <div className="menuBtn">
        <i className="fa-solid fa-bars"></i>
      </div>
      <div className="menu">
        <div id="logo">
          <Link to="/">
            <h2>Tropical Roleplay</h2>
          </Link>
        </div>
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/faq">FAQ</Link>
          </li>
          <li>
            <Link to="/applications">Applications</Link>
          </li>
          <li>
            <Link to="/staff">Staff</Link>
          </li>
          <li>
            <Link
              to="https://www.youtube.com/@TropicalRoleplayOfficial_"
              rel="noopener"
              target="_blank"
            >
              <button className="yt">
                <i className="fa-brands fa-youtube"></i>YouTube
              </button>
            </Link>
          </li>
          <li>
            <Link
              to="https://dsc.gg/tropicalroleplay"
              rel="noopener"
              target="_blank"
            >
              <button className="discord">
                <i className="fa-brands fa-discord"></i>Discord
              </button>
            </Link>
          </li>
        </ul>
        <button className="close">Close</button>
      </div>
    </>
  );
}
